const apiUrl = process.env.REACT_APP_API_URL;

export const updateUser = async (id, email, userName, roleId) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/users/updateUser`;
    const requestOptions = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
            id,
            email,
            userName,
            roleId
        })
    };

    try {
        const response = await fetch(url, requestOptions);
        const jsonResponse = await response.json();
        return jsonResponse.result;
    } catch (error) {
        return false;
    }
}

export const getUserToEdit = async (id) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/users/getUserToEdit/${id}`;
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    };
    
    try {
        const response = await fetch(url, requestOptions);
        const jsonResponse = await response.json();
        return jsonResponse;
    } catch (error) {
        return {};
    }
}